import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

export function* getHistory() {
  try {
    const { data } = yield call(request, API.HISTORY, 'GET');

    yield put(actions.getHistorySuccess(data));
  } catch (e) {
    yield put(actions.getHistoryError(e));
  }
}

export function* getHistoryWatcher() {
  yield takeEvery(constants.GET_HISTORY, getHistory);
}
